export const REQUEST_STATUS = { IDLE: 'idle', LOADING: 'loading', SUCCEEDED: 'succeeded', FAILED: 'failed' };

// The modal a card asked for; the page renders it from `selectOpenAccessEditor`.
export const EDITOR_TYPES = {
	CREATE_SCHEDULE: 'createSchedule',
	EDIT_SCHEDULE: 'editSchedule',
	MANAGE_DEVICE: 'manageDevice',
	MANAGE_ALL_DEVICES: 'manageAllDevices',
	MANAGE_PERSON: 'managePerson',
	MANAGE_ALL_PEOPLE: 'manageAllPeople'
};
